import React from "react";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-20 md:pt-24">
      <div className="relative h-[46vh] min-h-[340px] overflow-hidden bg-forest">
        {image && <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-forest via-forest/60 to-forest/40" />
        <div className="relative h-full container-lux flex flex-col justify-end pb-12">
          {eyebrow && <span className="eyebrow mb-3 animate-fade-up">{eyebrow}</span>}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-tight max-w-3xl animate-fade-up" style={{ animationDelay: "0.1s" }}>
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-cream/80 max-w-xl text-base sm:text-lg font-light animate-fade-up" style={{ animationDelay: "0.2s" }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
